var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('md-button',{staticClass:"md-just-icon md-warning md-simple table-action",on:{"click":_vm.triggerDetail}},[_c('md-icon',[_vm._v("visibility")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }